// extracted by mini-css-extract-plugin
module.exports = {"LogoMarcaWrapper":"Sucata_LogoMarcaWrapper__yGvSz","LogoMarca":"Sucata_LogoMarca__2VTGL"};